import React from 'react'
import FittipaldiBrothersComp from '../../components/sponsorships/FittipaldiBrothers'

const FittipaldiBrothers = () => {
  return (
   <FittipaldiBrothersComp/>
  )
}

export default FittipaldiBrothers